import { gql } from '@apollo/client';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const surfaceNodePositionUpdatedSubscription = gql`
  subscription surfaceNodePositionUpdated($surface: ID!, $user: ID!) {
    surfaceNodePositionUpdated(surface: $surface, user: $user) {
      ...surfaceNodeUnionDetails
    }
  }
  ${surfaceUnionFragment}
`;
